import AxiosService from './AxiosService'

class LicenseRestService {
  static getLicense(): Promise<any> {
    return AxiosService.get('/license')
  }

  static updateCustomerInfo(customerInfo: any): Promise<any> {
    return AxiosService.put('/license/customerInformation', customerInfo)
  }

  static deleteCustomerInfo(): Promise<any> {
    return AxiosService.delete('/license/customerInformation')
  }

  static acquireLicense(licenseInfo: any): Promise<any> {
    return AxiosService.put('/license/acquire', licenseInfo)
  }

  static processLicenseServerResponse(serverResponse: any): Promise<any> {
    return AxiosService.post('/license/processLicenseServerResponse', serverResponse)
  }

  static relinquishLicense(): Promise<any> {
    return AxiosService.put('/license/relinquish')
  }

  static acquireLicenseRequest(licenseInfo: number): Promise<any> {
    return AxiosService.post('/license/acquireRequest', licenseInfo, { responseType: 'blob' })
  }

  static verifyRequest(): Promise<any> {
    return AxiosService.get('/license/verifyRequest', { responseType: 'blob' })
  }

  static relinquishLicenseRequest(): Promise<any> {
    return AxiosService.get('/license/relinquishRequest', { responseType: 'blob' })
  }

  static deleteLicense(): Promise<any> {
    return AxiosService.delete('/license')
  }

  static offlineMode(): Promise<any> {
    return AxiosService.put('/license/mode', '"OFFLINE"', { headers: { 'Content-Type': 'application/json' } })
  }

  static onlineMode(): Promise<any> {
    return AxiosService.put('/license/mode', '"ONLINE"', { headers: { 'Content-Type': 'application/json' } })
  }
}

export default LicenseRestService
